import { render } from "./prices.vue?vue&type=template&id=2fda5fef"
import script from "./prices.vue?vue&type=script&lang=js"
export * from "./prices.vue?vue&type=script&lang=js"

import "./prices.vue?vue&type=style&index=0&id=2fda5fef&lang=scss"

import exportComponent from "C:\\www\\momentum_v2\\momentum\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__